import AppContext from "PFApp/app_context";
import PropTypes from "prop-types";
import React, { useContext } from "react";

import { isDraft } from "../../helpers";
import EngagementsRows from "./engagements_rows";

const EngagementsRowsConnected = ({ items, isLoading }) => {
  const {
    store: {
      pages: {
        workflowPage: {
          engagements: {
            columns,
            fetchData,
            pinnedIds,
            setPinnedIds,
            selectMode,
            setSelectMode,
            selectedIds,
            setSelectedIds,
            unseen: { markAsRead },
            data: { meta }
          }
        }
      }
    }
  } = useContext(AppContext);

  return (
    <EngagementsRows
      items={items}
      isLoading={isLoading}
      columns={columns}
      fetchData={fetchData}
      pinnedIds={pinnedIds}
      setPinnedIds={setPinnedIds}
      selectMode={selectMode}
      setSelectMode={setSelectMode}
      selectedIds={selectedIds}
      setSelectedIds={setSelectedIds}
      markAsRead={markAsRead}
      isDraft={isDraft(meta)}
      utmSource="workflow"
    />
  );
};

EngagementsRowsConnected.propTypes = {
  items: PropTypes.array.isRequired,
  isLoading: PropTypes.bool
};

export default EngagementsRowsConnected;
